import Vue from 'vue'
import moment from 'moment'

const generalModule = {
    state: {
        dateFrom: moment().subtract('1', 'years').format('YYYY/MM/DD'),
        dateTo: moment().format('YYYY/MM/DD')
    },
    mutations: {
        async SET_DATE_FROM (state, newVal) {
            state.dateFrom = newVal
            await Vue.API.AmfRequest(
                'iqistic.Order',
                'setDateFilter',
                [newVal, state.dateTo]
            )
        },
        async SET_DATE_TO (state, newVal) {
            state.dateTo = newVal
            await Vue.API.AmfRequest(
                'iqistic.Order',
                'setDateFilter',
                [state.dateFrom, newVal]
            )
        },
    },
    getters: {
        dateFrom(state) {
            return state.dateFrom
        },
        dateTo(state) {
            return state.dateTo
        }
    },
    actions: {
        setDateFrom (state, newVal) {

            state.commit('SET_DATE_FROM', newVal)
        },
        setDateTo (state, newVal) {
            state.commit('SET_DATE_TO', newVal)
        }
    }
}

export const state = generalModule.state
export const getters = generalModule.getters
export const mutations = generalModule.mutations
export const actions = generalModule.actions
